var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.082.083c141.384 0 256 114.587 256 256.035 0 141.377-114.616 255.964-256 255.964s-255.999-114.582-255.999-255.964c0-141.448 114.623-256.035 255.999-256.035z",
    fill: "#4caf50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.669 172.38a61.111 61.111 0 0 1 61.116 61.12 7.813 7.813 0 0 0 15.625 0 76.767 76.767 0 0 0 -76.741-76.733 7.806 7.806 0 1 0 0 15.611zm-11.793 49.978a7.806 7.806 0 1 1 0-15.611 40.078 40.078 0 0 1 40.1 40.09 7.813 7.813 0 0 1 -15.625 0 24.47 24.47 0 0 0 -24.47-24.479zm50.824 193.142c-24.677-4.358-49.029-15.679-70.285-28.662-24.588-15.036-47.555-33.778-67.927-54.156s-39.122-43.33-54.158-67.941c-12.972-21.253-24.323-45.612-28.657-70.276a34.681 34.681 0 0 1 .915-16.575 35.048 35.048 0 0 1 8.726-14.057l32.548-32.539a8.137 8.137 0 0 1 11.469 0l58.469 58.457a8.159 8.159 0 0 1 0 11.477l-31.074 31.083a13.124 13.124 0 0 0 -1.415 16.964 372.693 372.693 0 0 0 39.978 46.614 370.12 370.12 0 0 0 46.611 39.972 13.09 13.09 0 0 0 16.952-1.407l31.1-31.08a8.02 8.02 0 0 1 5.72-2.364 8.139 8.139 0 0 1 5.749 2.364l58.462 58.46a8.156 8.156 0 0 1 0 11.474l-32.549 32.542a33.612 33.612 0 0 1 -30.634 9.65zm-39.031-303.809a7.8 7.8 0 1 1 0-15.607 137.408 137.408 0 0 1 137.415 137.416 7.813 7.813 0 0 1 -15.626 0 121.8 121.8 0 0 0 -121.789-121.809z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.3e51e22b44b39dd2c01cdf0db94b4212.svg";
export { ForwardRef as ReactComponent };